<template>
  <div class="box">
    <div class="oneBox">
      <!-- 1 -->
      <div class="oneBoxCarousel">
        <ul>
          <li v-for="(item, index) in oneBoxCarouselCons" :key="index">
            <div class="oneBoxCarouselOne">
              <h1>{{ item.oneBoxCarouselConH1 }}</h1>
              <h2>{{ item.oneBoxCarouselConH2 }}</h2>
            </div>
          </li>
        </ul>
      </div>
      <!-- 2 -->
      <div class="BoxContent">
        <div class="BoxContentNames">Advantage</div>
        <div class="BoxContentName">公司优势</div>
        <div class="oneBoxAdvantageCon">
          <ul>
            <li v-for="item in oneBoxAdvantageCons" :key="item">{{ item }}</li>
          </ul>
        </div>
      </div>
      <!-- 3 -->
      <div class="BoxContent">
        <div class="BoxContentNames">Service</div>
        <div class="BoxContentName">专业服务</div>
        <div class="oneBoxServiceCon">
          <div
            class="oneBoxServiceConOne"
            v-for="(item, index) in oneBoxServiceCons"
            :key="index"
            @click="toProductIntroduction(item.id)"
          >
            <img :src="item.img" alt="" />
            <!-- <div class="oneBoxServiceConOneImg"></div> -->
            <div class="oneBoxServiceConOnetext">
              {{ item.text }}
              <!-- <div class="oneBoxServiceConOnetextMoves">{{ item.textAct }}</div> -->
            </div>
            <div class="oneBoxServiceConOnetextMobile">
              <p>{{ item.textMobile }}</p>
              {{ item.textMobiles }}
            </div>
            <div class="oneBoxServiceConOnetextAct">
              <div>{{ item.textAct }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
export default {
  data() {
    return {
      oneBoxCarouselCons: [
        {
          oneBoxCarouselConH1: "装修款专户监管，确保资金安全",
          oneBoxCarouselConH2:
            "装修宝是国禀科技联合金融机构推出的装修支付保障服务，保障装修收付款和售后服务。",
        },
        {
          oneBoxCarouselConH1: "装修全过程管控，保障施工品质",
          // oneBoxCarouselConH2: "装修大管家提供装修设计提升、材料优选、施工监管等10余次装修全过程管家式服务。",
          oneBoxCarouselConH2:
            "服务宝提供质保期内强制执行“24H响应+工作日48H完工”质保承诺，质保由第三方兜底、并赠送一年“全家保”三合一保险。",
        },
        {
          oneBoxCarouselConH1: "绿色装修，国标承诺，健康家首选",
          oneBoxCarouselConH2:
            "绿色装修管家向业主提供绿色建材优选、绿色施工、无忧退款等健康增值服务。装修全程一站式委托管理",
        },
      ],
      oneBoxAdvantageCons: [
        "行业领先的\n绿色装修理念",
        "更有保障的\n资金监管模式",
        "根源于地产的\n品质管控体系",
        "地产+建筑+监理\n复合型专业团队",
      ],
      oneBoxServiceCons: [
        {
          id: 1,
          img: require("@/pro/装修宝.webp"),
          // text: "装修宝：装修款、进度、质保三合一保障神器，“先装后付”不担心装修公司跑路和维修问题",
          // textAct:
          //   "装修宝是基于装修交易过程中的第三方安全支付增值服务，为装修收付款和装修售后服务提供保障，既有利于解决装修业主后顾之忧，也能够保障装修公司及时收款保障进度。",
          text: "装修宝：装修款、进度、质保三合一保障神器！",
          textMobile: "装修宝",
          textMobiles: "装修款、进度、质保三合一保障神器！",
          textAct: `装修宝实现装修款、进度、质保三合一保障，平台监管资金、按进度付款、平台兜底质保，有效防范装修公司跑路、恶意停工、逃避质保责任等风险，让业主装修资金安全无忧。 `,
        },
        {
          id: 3,
          img: require("@/pro/工程管家.webp"),
          // text: "工程管家：业主家的装修工程师。装修工程托管服务，装修款保障+工程质量保障+售后维修保障",
          text: "工程管家：业主家的装修工程师，全周期“以业主的立场”控制装修过程，控成本保质量。",
          textMobile: "工程管家",
          textMobiles:
            "业主家的装修工程师，全周期“以业主的立场”控制装修过程，控成本保质量。",
          // textAct:
          //   "工程管家是北京国禀科技有限公司基于房产开发甲方工程管理理念和工程项目代管代建模式，面向装修业主提供的全托管式装修工程管理服务。业主一次委托，享受装修全过程资金安全管理、设计提升、成本控制、材料验收、工程质量管理、装修资金安全管理和无忧售后等全方位贴身服务。",
          textAct:
            "工程管家专注于解决工程质量监管失位问题，为业主提供全托管式装修工程管理服务。业主一次委托，享受装修全过程资金安全管理、设计提升、成本控制、材料验收、工程质量管理、装修资金安全管理和无忧售后等全方位贴身服务，为业主打造舒适生活空间。",
        },
        // {
        //   img: require("@/pro/工程管家.webp"),
        //   text: "99验房：从房地产开发商购买房屋或通过安置等方式取得房屋的个人或单位",
        //   textAct:
        //     "99验房提供的服务保障：①专业团队：地产或建筑工程师+监理工程师+验房师；②检测全程三个标准化：仪器标准化、流程标准化、报告标准化；③检测项目全面无遗漏；④检测工作时长可量化；⑤全国化平台，全过程规范管理，随时接受业主监督反馈",
        // },
        {
          id: 2,
          img: require("@/pro/服务宝.webp"),
          text: "服务宝：质保期内第三方特别保障，质保维修无忧。",
          textMobile: "服务宝",
          textMobiles: "质保期内第三方特别保障，质保维修无忧。",
          // textAct:
          //   "服务宝是北京国禀科技有限公司联合银行和金融机构提供的售后保障平台，为业主提供装修交付后的“装修公司24H响应+工作日48H完工”强制服务承诺、“服务宝+24H完工”免费服务承诺”、“质保期满后八折服务费优惠”。赠送累计保额200万+的全家保（人身险，意外险，责任险，三险合一的保险产品）。",
          textAct:
            "服务宝专注于解决国家规定质保期维修问题，面对装修公司消失、上门拖、维修慢、修不好等售后难题，服务宝要求装修公司24h响应、48h提供解决方案，否则华美家平台介入代为解决，同时也赠送保险，保障业主权益。",
        },
        {
          id: 4,
          img: require("@/pro/绿装管家.webp"),
          text: "绿色装修管家：一站式绿色装修服务专家。90天入住承诺，安心装修、无忧入住。",
          textMobile: "绿色装修管家",
          textMobiles:
            "一站式绿色装修服务专家。90天入住承诺，安心装修、无忧入住。",
          // textAct:
          //   "绿色装修管家是北京国禀科技有限公司基于前沿的绿色建筑和房产项目代管代建模式，面向装修业主提供的全托管式绿色装修工程管理服务。业主一次委托，享受装修全过程资金安全管理、绿色设计、成本控制、绿色建材团购及验收、工程质量管理、三个月国标标准入住承诺和无忧售后等全方位贴身服务。",
          textAct:
            "绿色装修管家提供装修全程一站式委托管理，从资金监管、主辅材进场检查，到专业工程师巡检施工、隐蔽工程旁站监督，全方位把控装修过程，避免各类恶意装修中断、伪劣材料污染超标、隐蔽工程混乱、交付标准不达标等问题，保障工程质量和业主居住健康。 ",
        },
      ],
    };
  },

  methods: {
    toProductIntroduction(id) {
      this.$router.push({ name: "productIntroduction", params: { id } });
    },
  },
};
</script>
<style lang="scss" scoped>
.oneBox {
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
// 1
.oneBoxCarousel {
  //   position: absolute;
  //   left: 50%;
  //   transform: translateX(-50%);
  position: relative;
  top: -6rem;
  width: 70rem;
  text-align: left;
  background: #fff;
  z-index: 2;
  box-shadow: 0 0.5rem 2rem 0 rgba(29, 23, 23, 0.06);
}
.oneBoxCarousel ul {
  display: flex;
}
.oneBoxCarousel ul li {
  padding: 0 2rem;
  height: 100%;
}
.oneBoxCarouselOne {
  width: inherit;
  height: inherit;
  line-height: normal;
  font-size: 0.7rem;
  color: #211714;
}
.oneBoxCarouselOne h1 {
  font-size: 1rem;
  font-weight: 600;
  padding: 0.25rem 0;
}
.oneBoxCarouselOne h2 {
  font-size: 0.75rem;
  padding-top: 0.1rem;
  color: #60697f;
}
// 2
.oneBoxAdvantageCon {
  // background: #fff;
  padding: 1.25rem 0;
  box-shadow: 0 0.5rem 2rem 0 rgba(32, 35, 38, 0.1);
  background: url(../pro/优势背景.webp);
}
// .oneBoxAdvantageCon ul {
//   display: flex;
// }
.oneBoxAdvantageCon ul li {
  width: 25%;
  overflow: hidden;
  color: #fff;
  font-size: 1.5rem;
  font-weight: 600;
  position: relative;
  // 换行   与 \n 或 `` 一起使用
  white-space: pre-line;
}
.oneBoxAdvantageCon ul li + li:before {
  content: "";
  position: absolute;
  left: 0;
  top: 20%;
  bottom: 20%;
  width: 2px;
  background: #e7e6f4;
}

.oneBoxServiceCon {
  width: 100%;
  height: 39.75rem;
  position: relative;
  margin: auto;
  margin-bottom: 4rem;
  // background: #fff;
}
.oneBoxServiceConOne {
  width: 49%;
  position: absolute;
  overflow: hidden;
  text-align: left;
}
.oneBoxServiceConOne:first-child {
  height: 22.1rem;
  left: 0;
  top: 0;
}
.oneBoxServiceConOne:nth-child(2) {
  height: 16.6rem;
  right: 0;
  top: 0;
}
.oneBoxServiceConOne:nth-child(3) {
  height: 16.6rem;
  left: 0;
  bottom: 0;
}
.oneBoxServiceConOne:nth-child(4) {
  height: 22.1rem;
  right: 0;
  bottom: 0;
}
.oneBoxServiceConOne img {
  width: 100%;
  height: 100%;
  z-index: 1;
}
.oneBoxServiceConOnetextMobile {
  display: none;
}

.oneBoxServiceConOnetext {
  position: absolute;
  top: 1.8rem;
  left: 1.8rem;
  right: 1.4rem;
  font-weight: bold;
  color: rgb(255, 255, 255);
  font-size: 1.1rem;
}

.oneBoxServiceConOnetextAct {
  position: absolute;
  width: 100%;
  height: 100%;
  transition: transform 0.5s cubic-bezier(0.2, 0, 0.2, 1),
    -webkit-transform 0.5s cubic-bezier(0.2, 0, 0.2, 1);
  transform: translateY(0);
  background: rgba(0, 0, 0, 0.3);
  // 换行
  white-space: pre-line;
}
.oneBoxServiceConOnetextAct div {
  position: absolute;
  // width: 31rem;
  top: 5.2rem;
  left: 1.8rem;
  right: 1.4rem;
  font-size: 0.77rem;
  color: #fff;
}
.oneBoxServiceConOne:hover .oneBoxServiceConOnetextAct {
  transform: translateY(-100%);
}

.oneBoxServiceConOnetextMoves {
  display: none;
}

@media (max-width: 768px) {
  .oneBoxCarousel ul {
    flex-wrap: wrap;
  }
  .oneBoxAdvantageCon ul li {
    width: 50%;
    padding: 1rem 0;
  }

  .oneBoxServiceCon {
    // width: 34.6rem;
    margin: auto;
    width: 94%;
    height: auto;
    // padding: 1rem;
  }
  .oneBoxServiceConOne {
    position: relative;
    margin-top: 2rem;
    width: 100%;
  }
  .oneBoxServiceConOne:first-child {
    height: 18rem;
  }
  .oneBoxServiceConOne:nth-child(2) {
    height: 14rem;
  }
  .oneBoxServiceConOne:nth-child(3) {
    height: 14rem;
  }
  .oneBoxServiceConOne:nth-child(4) {
    height: 18rem;
  }
  .oneBoxServiceConOnetextAct {
    display: none;
  }
  .oneBoxServiceConOnetextMoves {
    display: block;
    margin-top: 0.5rem;
    font-size: 0.7rem;
    font-weight: 500;
  }

  // 最新改  未定
  .oneBoxServiceConOne {
    background: #fff;
    border-radius: 0.5rem;
  }
  .oneBoxServiceConOne img {
    width: 58%;
    border-radius: 0.3rem;
  }
  .oneBoxServiceConOne:first-child {
    height: 13rem;
  }
  .oneBoxServiceConOne:nth-child(2) {
    height: 13rem;
  }
  .oneBoxServiceConOne:nth-child(3) {
    height: 13rem;
  }
  .oneBoxServiceConOne:nth-child(4) {
    height: 13rem;
  }
  .oneBoxServiceConOnetext {
    display: none;
  }
  .oneBoxServiceConOnetextMobile {
    display: block;
    font-size: 1.4rem;
    left: 61%;
    right: 0.2rem;
    top: 1.1rem;
    color: #423939;
    position: absolute;
    // font-weight: bold;
  }
  .oneBoxServiceConOnetextMobile p {
    margin: 0;
    padding-bottom: 0.7rem;
    font-size: 1.83rem;
    color: #27ae61;
    font-weight: bold;
  }
}
@media (max-width: 480px) {
  .oneBoxCarousel {
    top: -2rem;
  }
  .oneBoxServiceConOne {
    margin-top: 1rem;
    position: relative;
  }
  .oneBoxServiceConOneImg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
  }
  .oneBoxServiceConOne:first-child {
    // height: 15rem;
    height: 12rem;
  }
  .oneBoxServiceConOne:nth-child(2) {
    height: 12rem;
  }
  .oneBoxServiceConOne:nth-child(3) {
    height: 12rem;
  }
  .oneBoxServiceConOne:nth-child(4) {
    // height: 15rem;
    height: 12rem;
  }
  .oneBoxServiceConOnetext {
    font-size: 1rem;
    left: 1rem;
  }
  .oneBoxServiceConOnetextAct div {
    left: 1rem;
    top: 4.7rem;
  }

  // 最新改  未定
  .oneBoxServiceConOne:first-child {
    height: 8rem;
  }
  .oneBoxServiceConOne:nth-child(2) {
    height: 8rem;
  }
  .oneBoxServiceConOne:nth-child(3) {
    height: 8rem;
  }
  .oneBoxServiceConOne:nth-child(4) {
    height: 8rem;
  }

  .oneBoxServiceConOnetextMobile {
    font-size: 0.9rem;
    top: 0.8rem;
    line-height: 1.2rem;
  }
  .oneBoxServiceConOnetextMobile p {
    font-size: 1.3rem;
  }
}
</style>
    